import {brands} from "./Data";
import {Component} from "react";

/* ===== SESSION ===== */

const SESSION_BASE = "https://session.animotech.ru/"; // ← проверь базу

let SID = null;

function setSid(sid) {
	SID = sid;
}

export async function ensureSession(force = false) {
	const res = await fetch(SESSION_BASE, {
		method: "GET",
	});

	if (!res.ok) {
		const txt = await res.text().catch(() => "");
		throw new Error(`ensureSession failed: ${res.status} ${txt}`);
	}

	const data = await res.text();
	console.log("SESSION:", data);

	if (data) setSid(data.replace(/"/g, ""));
	return data;
}

class Api extends Component {
    getItemUsingID = async (id) => {
				const body = {
					cmd: "getProduct",
					id: id
				}
        return fetch('https://app.animotech.ru/ords/-/api/2.0', {
	        method: "POST",
	        headers: {
		        "Content-Type": "application/json",
		        sid: SID,
	        },
	        body: JSON.stringify(body),
        })
            .then(r => {
                if (r.status !== 401) return r.json();
                else return false
            })
            .then(rJson => {
                if (rJson) {
                    let res = rJson.data;
                    return res.length === 0 ? null : res
                }
                else return false
            })
    };
	searchItems = async ({ category = "", term = "", page = 1 }) => {
		return new Promise((resolve) => {
			const url = "https://app.animotech.ru/ords/-/api/2.0";

			const body = {
				cmd: "getProducts",
				data: {
					start_row: 1 + (page - 1) * 24,
					rows: 24,
					channel_id: "304007118",
					files: 1,
					optionalAttrs: [53049077, 53049085, 53052943],
					filter: [],
				},
			};

			if (category) {
				let categoryId = brands.find(item => item.id === category);
				if (category && category.length > 0) {
					body.data.filter.push({
						attr_name: "Бренд (MARS) - ecom",
						attr_value: categoryId.value_ru,
					});
				}
			}

			if (term && term.trim()) {
				body.data.search_mode = "any";
				body.data.search_text = term.trim();
			}

			fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					sid: SID,
				},
				body: JSON.stringify(body),
			})
				.then((r) => r.json())
				.then((rJson) => {
					const data = rJson.data;
					const totalLength = rJson.total_rows;
					resolve({ data, totalLength });
				})
				.catch(() => {});
		});
	};

	fetchData = async (page, filter, cat, search) => {
				const body = {
					cmd: "getProducts",
					data: {
						start_row: 1 + (page - 1) * 24,
						rows: 24,
						channel_id: 1364183823,
						files: 1,
						facets_data:[{facet_type: "CHECKBOX_GROUP", attr_id: 1345936328 }, {facet_type: "CHECKBOX_GROUP", attr_id: 1345938927}],
						optionalAttrs: [1345936328,1345938927],
						filter: [],
					},
				};
        if (search) {
	        body.data.search_mode = "any";
	        body.data.search_text = search;
        }
        if (filter) {
	        body.data.facets_data[0].checked = [filter]
        }
        if (cat) {
	        body.data.facets_data[1].checked = [cat]
        }
				console.log(body)
        const response = await fetch(
	        "https://app.animotech.ru/ords/-/api/2.0",
          {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
	              sid: SID
              },
              body: JSON.stringify(body)
          }
        );
        const responseJson = await response.json();
        if (!response.ok) {
            return;
        }
        return responseJson
    }
    fetchItem = async (id) => {
	    const body = {
		    cmd: "getProduct",
		    id: id
	    }
        const response = await fetch(
	        "https://app.animotech.ru/ords/-/api/2.0",
          {
              method: "POST",
	          headers: {
		          "Content-Type": "application/json",
		          sid: SID,
	          },
	          body: JSON.stringify(body),
          }
        );
        const responseJson = await response.json();
        if (!response.ok) {
            return;
        }
        return responseJson.data
    }
}

export default new Api();
